import { call, put, takeLatest } from "redux-saga/effects";
import {
  getAccountDetailsListApi,
  updateAccountPasswordListApi,
} from "../requests/accountRequests";
import { toast } from "react-toastify";
import { AccountActions } from "../../action-types/accountActionTypes";
import {
  setAccountDetailsList,
  setIsOpenModelEditAccountPassword,
} from "../../actions/accountAction";
import {
  setLoader,
  setLoaderSaveButton,
  setLoaderUserAccountPasswordButton,
} from "../../actions/userActions";
import {
  uploadFilesDefectsDetailListApi,
  uploadFilesDefectsDetailDynamicApi,
} from "../requests/defectsRequests";
import { updateUserMasterListApi } from "../requests/mastersRequests";

function* getAccountDetailsHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getAccountDetailsListApi, action.payload.id);
    if (data.status) {
      yield put(setAccountDetailsList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function fileToBlob(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = () => {
      const blob = new Blob([reader.result], { type: file.type });
      resolve(blob);
    };

    reader.readAsArrayBuffer(file);
  });
}

function* updateAccountDetailsHandler(action) {
  yield put(setLoaderSaveButton(true));
  // start loader here
  try {
    let payload = {
      first_name: action?.payload?.first_name,
      last_name: action?.payload?.last_name,
      email: action?.payload?.email,
      phone: action?.payload?.phone,
      username: action?.payload?.username,
      company_id: action?.payload?.company_id,
      role_id: action?.payload?.role_id,
      id: action?.payload?.id,
    };

    if (action.payload.Profile_image !== null) {
      const payload1 = {
        contentType: action?.payload?.Profile_image?.type,
      };
      const Filesdata = yield call(uploadFilesDefectsDetailListApi, payload1);
      payload = {
        ...payload,
        profile_image: Filesdata?.data?.data?.key,
      };
      if (Filesdata?.data?.status) {
        const AWSUrl = yield call(uploadFilesDefectsDetailDynamicApi, {
          url: Filesdata?.data?.data?.URL,
          file: action?.payload?.Profile_image,
        });
      } else {
        // Handle unsuccessful response
      }
    }

    console.log("fguitgfowhiujgoi", payload);

    const { data } = yield call(updateUserMasterListApi, payload);

    if (data.status) {
      yield put(setLoaderSaveButton(false));
      toast.success(data.message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
    }
    // handle response here and set into reducer
  } catch (error) {
    yield put(setLoaderSaveButton(false));
    // handle error
  } finally {
    //stop loader here
    // yield put(setLoader(false));
    yield put(setLoaderSaveButton(false));
  }
}

function* updateAccountPasswordHandler(action) {
  // start loader here
  yield put(setLoaderUserAccountPasswordButton(true));
  try {
    const { data } = yield call(updateAccountPasswordListApi, action.payload);
    if (data.status) {
      yield put(setIsOpenModelEditAccountPassword(false));
      yield put(setLoaderUserAccountPasswordButton(false));
      toast.success(data.message);
    } else {
      yield put(setIsOpenModelEditAccountPassword(true));
      yield put(setLoaderUserAccountPasswordButton(false));
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoaderUserAccountPasswordButton(false));
  }
}

// accountHandler Sagas
export default function* accountSaga() {
  yield takeLatest(
    AccountActions.GET_USER_ACCOUNT_DETAILS_LIST,
    getAccountDetailsHandler
  );
  yield takeLatest(
    AccountActions.UPDATE_USER_ACCOUNT_DETAILS,
    updateAccountDetailsHandler
  );
  yield takeLatest(
    AccountActions.UPDATE_USER_ACCOUNT_PASSWORD,
    updateAccountPasswordHandler
  );
}
